import { api } from '../api';
import { showBadToast, showGoodToast } from '../../errors/toast';
import logMessage from '../../errors/foutlog';
import {
    Onderhoud,
    OnderhoudLijst,
    OnderhoudsType,
    OnderhoudsActivity
} from '../../../models/Onderhoud';
const actions = {
    async deleteMaintenance(context, data) {
        try {
            await api.deleteMaintenance(data.data);
            showGoodToast(
                context,
                data.func('com_verwijderd', {
                    ns: 'common',
                    val: data.func('prod_reinigingsitem', { ns: 'production' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('prod_reinigingsitem', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
    },
    async loadMaintenanceOverPeriod(context, data) {
        let tempList = [];
        try {
            await api.fetchMaintenanceOverPeriod(data.data).then((res) => {
                tempList = res.data.Items.map((x) => {
                    const prod = new Onderhoud(x);
                    prod.attachmentinfo = prod.geefAttInfo(data.func);
                    return prod;
                });
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('prod_reinigingsinfo', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertMaintenanceLijst', tempList);
    },
    async loadMaintenanceInfoOverPeriod(context, data) {
        let tempList = [];
        try {
            await api.fetchMaintenanceInfoOverPeriod(data.data).then((response) => {
                tempList = response.data.Items.map((x) => new Onderhoud(x));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorverwijder', {
                    ns: 'common',
                    val: data.func('prod_reinigingsinfo', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertMaintenanceInfoLijst', tempList);
    },
    async loadMaintenance(context, data) {
        let item = null;
        try {
            const response = await api.fetchMaintenance(data.data);
            item = new OnderhoudLijst(response.data);
        } catch (error) {
            item = null;
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_reinigingsinfo', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        return item;
    },
    async addMaintenance(context, data) {
        try {
            await api.addMaintenance(data.data);
            showGoodToast(
                context,
                data.func('com_opgeslagen', {
                    ns: 'common',
                    val: data.func('prod_reiniging', { ns: 'production' })
                })
            );
        } catch (error) {
            showBadToast(
                context,
                data.func('com_erroropslaan', {
                    ns: 'common',
                    val: data.func('prod_reiniging', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
    },

    async loadMaintenanceActivities(context, data) {
        let tempList = [];
        try {
            await api.fetchMaintenanceActivities(data.data).then((response) => {
                tempList = response.data.map((x) => new OnderhoudsActivity(x, data.func));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_activities', { ns: 'production' })
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertOnderhoudsActivitiesLijst', tempList);
    },
    async loadMaintenaceTypes(context, data) {
        let tempList = [];
        try {
            await api.fetchMaintenaceTypes(data.data).then((response) => {
                tempList = response.data.map((x) => new OnderhoudsType(x, data.func));
            });
        } catch (error) {
            tempList = [];
            showBadToast(
                context,
                data.func('com_errorladen', {
                    ns: 'common',
                    val: data.func('prod_type', { ns: 'production' }).toLowerCase()
                }),
                error
            );
            logMessage(error, 'error');
        }
        context.commit('insertOnderhoudsTypesLijst', tempList);
    },
};

export default actions;
